// utilities/linkedinPixel.ts

declare global {
    interface Window {
      _linkedin_partner_id: string;
      _linkedin_data_partner_ids: string[];
      lintrk: any;
    }
  }
  
  export function addLinkedInPixel() {
    if (window._linkedin_partner_id) return; // যদি ইতিমধ্যে লোড হয়ে থাকে, পুনরায় লোড করবেন না
  
    // LinkedIn Insight Tag ইনিশিয়ালাইজ করা
    window._linkedin_partner_id = "53795";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
  
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.innerHTML = `
      (function(l) {
        if (!l){
          window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    `;
    document.head.appendChild(script1);
  
    // noscript ট্যাগ লোড করা
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=53795&fmt=gif" />`;
    document.body.appendChild(noscript);
  }
  